import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import {
  useGetCodTransferDetailQuery,
  useUpdateCodTransferMutation,
} from "store/services/PaymentsApi/codTransferApi";

import CodTransferForm from "./codTransferComponents/CodTransferForm";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAppMeta } from "hooks";

const CodTransferEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "COD Transfer", path: "/app/crm/cod-transfer/list" },
    { title: "Edit COD Transfer" },
  ];

  const {
    data: codTransferDetail,
    isLoading: loadingCodTransfer,
    error,
  } = useGetCodTransferDetailQuery(id);

  const [updateCodTransfer, { isLoading: updatingCodTransfer }] =
    useUpdateCodTransferMutation();

  const handleUpdateCodTransfer = async (data) => {
    const _payload = { ...data, _id: id };

    try {
      await updateCodTransfer(_payload).unwrap();
      toast.success("COD Transfer successfully updated!");
      navigate(`/app/crm/cod-transfer/${id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ??
          err?.message ??
          "Couldn't update COD Transfer!"
      );
    }
  };

  useAppMeta("Edit COD Transfer");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingCodTransfer || updatingCodTransfer}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <CodTransferForm
          isBusy={loadingCodTransfer || updatingCodTransfer}
          codTransferDetails={codTransferDetail}
          onSubmit={handleUpdateCodTransfer}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default CodTransferEditScreen;